import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import es from 'date-fns/locale/es';

import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import './PollsReport.scss';

registerLocale('es', es)

function PollsReport() {
  const [report, setReport] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  

  const [filters, setFilters] = useState({
    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'pollId': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
    'ticket': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'answer1': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'answer2': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'comments': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'email': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'phoneNumber': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'name': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] }
  });
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [loading, setLoading] = useState(false);
  const rates = ['Excelente', 'Muy Bueno', 'Satisfactorio', 'Esperaba más', 'Inaceptable'];

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, []);
  
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters['global'].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  }  

  const onSearchClick = () => {
    setReport([]);
    getReport(startDate.valueOf(), endDate.valueOf());
  };
  
  const getReport = (startDate, endDate) => {   
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/airportService/v1/poll/getAll?start=${startDate}&end=${endDate}`)
    .then(response => response.json())
    .then(data => {
      if (data.responseCode === 'OK') {
        const _report = data.responseObject;
        console.log("report", _report);
        setReport(_report);
      }
      setLoading(false);
    });
  }

  const statusItemTemplate = (option) => {
    return <span>{option}</span>;
  }
  
  const ratesFilterTemplate = (options) => {
    return <Dropdown value={options.value} options={rates} onChange={(e) => options.filterCallback(e.value, options.index)} itemTemplate={statusItemTemplate} placeholder="Selecciona una calificación" className="p-column-filter" showClear />;
  }

  const improvementItemTemplate = (option) => {
    return <span>{option}</span>;
  }

  const improvementsFilterTemplate = (options) => {
    return <Dropdown value={options.value} options={rates} onChange={(e) => options.filterCallback(e.value, options.index)} itemTemplate={improvementItemTemplate} placeholder="Selecciona una mejora" className="p-column-filter" showClear />;
  }

  const reportHeaderTemplate = (
    <>
      <Row>
        <Col>
          <span className="p-input-icon-left">
            <i className="pi pi-filter" />
            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Filtrar" className='p-inputtext-sm' />
          </span>
        </Col>
      </Row>
    </>
  );
  
  const reportTemplate = (
    <>
      <article>
        <Row>
          <Col>
            <h1 className='app-font'>
              Reporte de Encuestas
            </h1>
          </Col>
        </Row>

        <Row>
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label>
                Start date
              </Form.Label>
              <DatePicker
                controlId="startDateInput"
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                locale="es"
                className="w-100 app_datepicker" />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label>
                End date
              </Form.Label>
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                locale="es"
                className="w-100 app_datepicker" />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Button
              type="button"
              icon="pi pi-search"
              onClick={onSearchClick}
              className="p-button-sm p-button-primary p-button-raised"
              label='Buscar' />
          </Col>
        </Row>
        <Row className='pt-2'>
          <Col>

            <div className='datatable-doc-demo'>
              <div className="card">
                <DataTable
                  value={report}
                  paginator
                  className="p-datatable-customers"
                  showGridlines
                  stripedRows
                  header={reportHeaderTemplate}
                  rows={50}
                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                  rowsPerPageOptions={[10, 25, 50]}
                  filters={filters} filterDisplay="menu"
                  loading={loading}
                  responsiveLayout="scroll"
                  globalFilterFields={[
                    'pollId',
                    'ticket',
                    'answer1',
                    'answer2',
                    'comments',
                    'email',
                    'phoneNumber',
                    'name',
                  ]}
                  emptyMessage="No customers found."
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
                  <Column field="pollId" header="ID de encuesta" sortable filter filterPlaceholder="Buscar por pollId" className='app-w-250-px text-end' />
                  <Column field="ticket" header="Ticket" sortable filter filterPlaceholder="Buscar por ticket" className='app-w-200-px text-end' />
                  <Column field="answer1" header="¿Cómo calificas nuestro servicio?" sortable filterMenuStyle={{ width: '14rem' }} filter filterElement={ratesFilterTemplate} className='app-w-400-px text-start' />
                  <Column field="answer2" header="¿Qué podemos mejorar?" sortable filterMenuStyle={{ width: '14rem' }} filter filterElement={improvementsFilterTemplate} className='app-w-300-px text-start' />
                  <Column field="comments" header="Comentarios" sortable filter filterPlaceholder="Buscar por comments" className='app-w-500-px text-start' />
                  <Column field="email" header="Correo electrónico" sortable filter filterPlaceholder="Buscar por email" className='app-w-350-px text-start' />
                  <Column field="phoneNumber" header="Número telefónico" sortable filter filterPlaceholder="Buscar por phoneNumber" className='app-w-250-px text-start' />
                  <Column field="name" header="Nombre" sortable filter filterPlaceholder="Buscar por name" className='app-w-250-px text-start' />
                </DataTable>
              </div>
            </div>
          </Col>
        </Row>
      </article>
    </>
  );
      
  return (
    <>
      {reportTemplate}
    </>
  );
}

export default PollsReport;